export const durationsInMinutes: number[] = [15, 30, 45, 60, 90, 120, 180, 240, 300, 360, 420, 480];

export const bookRoomDurationsInMinutes: number[] = [15, 30, 45, 60, 90, 120];

export const defaultDurationInMinutes = durationsInMinutes[1];

export const roomAvailabilityPeriodOfInterest = 15;
